import React from 'react';

const VALUE_COLORS = {
  positive: '#96e6ab',
  negative: '#df87a8',
  neutral: '#444',
};

function StatCard({ title, value, subtitle, tone = 'neutral' }) {
  const color = VALUE_COLORS[tone] || VALUE_COLORS.neutral;

  return (
    <div className="stats-card">
      <h2>{title}</h2>
      <p style={{ color }}>{value ?? '—'}</p>
      {subtitle ? (
        <p
          className="stats-card-subtitle"
          style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#666', marginTop: '4px' }}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}

export default StatCard;
